import { setScrollToTime } from '@/apps/mwd-v2/state/actions/scrollToTime';
import useMwdTimescale from '@/apps/mwd-v2/state/selectors/useMwdTimescale';
import { MwdDeeltraject, MwdWerklijn } from '@/apps/mwd-v2/types/Domain';

type UseDetailPanelHeaderProps = {
  werklijn?: MwdWerklijn;
  mwdDeeltraject?: MwdDeeltraject;
  selectDeeltraject: (deeltraject: MwdDeeltraject) => void;
};

export function useDetailPanelHeader({ werklijn, mwdDeeltraject, selectDeeltraject }: UseDetailPanelHeaderProps) {
  const { scale } = useMwdTimescale();

  const handleNextInzetClick = () => {
    if (!werklijn || !mwdDeeltraject) return;
    const currentIndex = werklijn.deelTrajecten?.findIndex((d) => d.wleId === mwdDeeltraject?.wleId);
    if (currentIndex === undefined || currentIndex < 0) return;

    let nextIndex = currentIndex + 1;
    while (
      nextIndex < (werklijn.deelTrajecten?.length ?? 0) &&
      werklijn.deelTrajecten?.[nextIndex]?.claimsoort !== null
    ) {
      nextIndex++;
    }

    const nextInzet = werklijn.deelTrajecten?.[nextIndex];
    if (nextInzet && nextInzet.claimsoort === null) {
      selectDeeltraject(nextInzet);
      const x = scale(nextInzet.vertrekTijd);
      setScrollToTime(x);
    }
  };

  const handlePrevInzetClick = () => {
    if (!werklijn || !mwdDeeltraject) return;
    const currentIndex = werklijn.deelTrajecten?.findIndex((d) => d.wleId === mwdDeeltraject?.wleId);
    if (currentIndex === undefined || currentIndex < 0) return;

    let prevIndex = currentIndex - 1;
    while (prevIndex >= 0 && werklijn.deelTrajecten?.[prevIndex]?.claimsoort !== null) {
      prevIndex--;
    }

    const prevInzet = werklijn.deelTrajecten?.[prevIndex];
    if (prevInzet && prevInzet.claimsoort === null) {
      selectDeeltraject(prevInzet);
      const x = scale(prevInzet.vertrekTijd);
      setScrollToTime(x);
    }
  };

  return {
    handleNextInzetClick,
    handlePrevInzetClick,
  };
}
